import styled from '@emotion/styled';
interface TabContentProps {
	open: boolean;
}
interface TabStickyProps {
	isNotSticky: boolean;
}
export const TabListContainer = styled.div<TabStickyProps>`
	position: ${({ isNotSticky }) => (isNotSticky ? '' : 'sticky')};
	top: ${(props) => props.theme.heights.header};
	z-index: 9;
	display: flex;
	height: 5.2rem;
	background: white; // 배경색 추가해서 투명 배경 문제 방지
	max-width: 135rem;
	width: 100%;
	margin: 0 auto;
	@media screen and (max-width: 1180px) {
		top: ${(props) => props.theme.heights.headerMobile};
	}
`;
export const TabListItem = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 1;
	border-bottom: 2px solid #dee2e6;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	color: #868e96;
	cursor: pointer;
	&.active {
		color: ${(props) => props.theme.colors.primary400};
		border-bottom: 2px solid ${(props) => props.theme.colors.primary400};
	}
`;

export const DropdownContainer = styled.div<TabStickyProps>`
	width: 100%;
	position: ${({ isNotSticky }) => (isNotSticky ? '' : 'sticky')}; // 여기!
	top: ${(props) => props.theme.heights.headerMobile};
	z-index: 9;
`;
export const DropdownWrapper = styled.div<TabStickyProps>`
	position: relative;
	display: flex;
	flex-direction: column; // 드롭다운이 아래로 쌓이도록
	border-top: 1px solid ${({ isNotSticky }) => (isNotSticky ? '#DEE2E6' : '')};
`;

export const DropdownButton = styled.button`
	width: 100%;
	height: 5.2rem;
	padding: 0rem 2rem;
	background: white;
	border: none;
	border-bottom: 1px solid #e9ecef;
	cursor: pointer;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const DropdownList = styled.ul<TabContentProps>`
	position: absolute;
	top: 5.2rem;
	width: 100%;
	background: white;
	border-bottom: 1px solid #e9ecef;
	border-radius: 0px;
	list-style: none;
	padding: 0;
	display: ${({ open }) => (open ? 'block' : 'none')};
	overflow-y: auto;
	z-index: 10;
`;

export const DropdownItem = styled.li`
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	padding: 1.6rem 2rem;
	cursor: pointer;
	&:hover {
		color: ${(props) => props.theme.colors.primary400};
	}
`;

export const ArrowDown = styled.div<TabContentProps>`
	padding-left: 0.4rem;
	transition: transform 0.2s;
	${({ open }) => open && 'transform: rotate(180deg);'}
`;
